module.exports = __webpack_public_path__ + "img/logo-shenglianyun.c356d777.png";